<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
    <p class="top_p">
      钱湖柏庭文艺俱乐部有8个社团，分别是交谊舞社团、京剧社团、民舞社团、模特社团、体育舞社团、甬剧社团、越剧社团、中国舞社团。
    </p>
    <p class="top_p title" style="margin: 0">一、交谊舞社团</p>
    <p class="top_p" style="margin: 0">
      交谊舞又称舞厅舞、舞会舞、社交舞，是一种抒发感情，陶冶人们的心灵和情操，培养人们的能力和修养，极其文雅的舞蹈。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的交谊舞社团，让长者们放开心扉，交流无碍，大家以默契的舞步和含蓄的形体，伴着舞曲节奏，展现出高度的和谐，不失为一种交友的艺术桥梁。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">二、京剧社团</p>
    <p class="top_p" style="margin: 0">
      京剧，又称平剧、京戏，是中国影响最大的戏曲剧种，分布地以北京为中心，遍及全国各地。
    </p>
    <p class="top_p" style="margin: 0">
      京剧在文学、表演、音乐、舞台美术等各个方面都有一套规范化的艺术表现形式。
    </p>
    <p class="top_p" style="margin: 0">
      来柏庭京剧社团，感受国粹的魅力，开腔一首，艳惊四座~
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_1.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">三、民舞社团</p>
    <p class="top_p" style="margin: 0">在这里，长者们一起跳舞、一起训练。</p>
    <p class="top_p" style="margin: 0">
      大家在紧张的练习中相互扶持，长者们身影飞舞，静若处子动若脱兔，足尖生花，激情勃发，彼此的友谊在音乐中交融升华。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_2.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">四、模特社团</p>
    <p class="top_p" style="margin: 0">这儿的长者个个都是长腿女神~</p>
    <p class="top_p" style="margin: 0">
      婀娜的身姿，曼妙的步伐，能将所有人的眼光吸引，有气质、有韵味、有活力的她们，充分展示了新时代中老年人热爱生活，追求美好的精神风貌。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_3.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">五、体育舞社团</p>
    <p class="top_p" style="margin: 0">
      体育舞蹈运动是一项新兴的体育项目，是体育与舞蹈的结合，具有运动与艺术的双重性。
    </p>
    <p class="top_p" style="margin: 0">
      这种极赋时代气息和体育竞技性质的舞蹈在柏庭的体育舞社团中，被长者们融汇贯通，即兴便能来上一段！
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_4.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">六、甬剧社团</p>
    <p class="top_p" style="margin: 0">
      甬剧，浙江宁波地方传统戏剧，国家级非物质文化遗产之一。它是用浙江宁波方言演唱的地方戏曲剧种，音乐声腔属于滩簧。
    </p>
    <p class="top_p" style="margin: 0">
      在柏庭甬剧社团体验非遗，能感受传统文化的魅力。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_5.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">七、越剧社团</p>
    <p class="top_p" style="margin: 0">
      越剧是中国第二大剧种，发源于绍兴嵊州，先后在杭州和上海发展壮大起来，流行于全国，流传于世界，越剧真切动人，唯美典雅，极具江南灵秀之气。
    </p>
    <p class="top_p" style="margin: 0">
      越剧社团汇聚的就是这么一群典雅灵秀的江南才子佳人。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_6.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">八、中国舞社团</p>
    <p class="top_p" style="margin: 0">
      中国古典舞是经过历代专业舞者、学者的创造、整理、提炼、加工，并经过较长期艺术实践的检验流传下来的具有一定典范意义的中国古典风格的特色舞蹈。
    </p>
    <p class="top_p" style="margin: 0">
      热爱古典舞的长者们，必然是身心皆修的温柔的人，因为柏庭中国舞社团便是一众女神的聚集地啦！
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/wenyi_7.jpg" alt="" />
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        },
      ],
      newData: 2,
      list2: [
        {
          img: require("../../assets/image/party/lvyou_1.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_2.png"),
        },
        {
          img: require("../../assets/image/party/lvyou_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.small_jiantou {
  display: inline-block;
  width: 0.1rem;
  height: 0.1875rem;
  background-image: url("../../assets/image/left_item1.png");
  background-size: 100% 100%;
}
.item_jiantou1 {
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2 {
  background-image: url("../../assets/image/left_item2.png");
  background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>